import { useSelector } from "react-redux";
import { interactionStateSelector } from "../redux/interactionSelectors";
import { useMemo } from "react";
import { checkStateFulfillment } from "../utils/checkStateFulfillment";

export function useFulfillState(stateRequirement: StateSpec | undefined, defaultEmptyStateResult = false) {
  const interactionState = useSelector(interactionStateSelector);

  return useMemo(() => {
    if (!stateRequirement || Object.keys(stateRequirement).length === 0) {
      return defaultEmptyStateResult;
    }
    return checkStateFulfillment(stateRequirement, interactionState)
  }, [defaultEmptyStateResult, interactionState, stateRequirement])
}